import { createApp } from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import SmartTable from 'vuejs-smart-table'

const options = {
    confirmButtonColor: '#41b882',
    cancelButtonColor: '#ff7674',
};
import store from './store.js'
import services from "../services"
import constants from "../services/constants"

window._ = require('lodash')
window.services = services

window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

const app = createApp({
    data() {
        return {
            constants: constants,
            _configs: _configs,
            moment: require('moment'),
    }
    }
})

const files = require.context('./components', true, /\.vue$/i);
files.keys().map(key => app.component(key.split('/').pop().split('.')[0], files(key).default));

app.use(store);
app.use(VueSweetalert2, options);
app.use(SmartTable)
app.mount('#front');

